import * as React from 'react';

function SvgSmile(props) {
  return (
    <svg width={26} height={26} fill="none" viewBox="0 0 26 26" {...props}>
      <path d="M13 0C5.81953 0 0 5.81953 0 13C0 20.1805 5.81953 26 13 26C20.1805 26 26 20.1805 26 13C26 5.81953 20.1805 0 13 0ZM17.0625 8.9375C17.9608 8.9375 18.687 9.66367 18.687 10.5625C18.687 11.4613 17.9608 12.1875 17.0625 12.1875C16.1642 12.1875 15.4365 11.4613 15.4365 10.5625C15.4365 9.66367 16.1637 8.9375 17.0625 8.9375ZM8.8918 8.9375C9.79012 8.9375 10.5178 9.66367 10.5178 10.5625C10.5178 11.4613 9.79012 12.1875 8.8918 12.1875C7.99348 12.1875 7.2673 11.4613 7.2673 10.5625C7.2673 9.66367 8.03867 8.9375 8.8918 8.9375ZM18.8297 17.5805C17.3824 19.3172 15.2598 20.2668 13 20.2668C10.7402 20.2668 8.6191 19.274 7.17031 17.5368C6.4802 16.7091 7.72637 15.6731 8.41801 16.4958C9.55703 17.9055 11.2227 18.6824 13 18.6824C14.7773 18.6824 16.444 17.8994 17.5805 16.5384C18.2609 15.7168 19.5152 16.7527 18.8297 17.5805Z" />
    </svg>
  );
}

export default SvgSmile;
